module.exports = __webpack_public_path__ + "img/billboard.14f45bc5.svg";